// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.VendorOffer')
class Orders__VendorOffer {
    @jsonProperty(() => Orders__VendorOffer.Id)
    id: Orders__VendorOffer.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "vendor", "vendor$id", "status", "status$id", "receivedOn", "messageId", "sender", "currency", "currency$id", "requestHtml", "priceShipping", "bodyText", "requestedItemIds", "discountPercent", "offerNumber", "request", "requestId", "items", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "vendor", "vendor$id", "status", "status$id", "receivedOn", "messageId", "sender", "currency", "currency$id", "requestHtml", "priceShipping", "bodyText", "requestedItemIds", "discountPercent", "offerNumber", "request", "requestId", "items", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "vendor", "status", "receivedOn", "messageId", "sender", "currency", "requestHtml", "priceShipping", "bodyText", "requestedItemIds", "discountPercent", "offerNumber", "request", "requestId", "items", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "vendor": "Orders.Vendor", "vendor$id": "number", "status": "Orders.VendorOfferStatus", "status$id": "string", "receivedOn": "Date", "messageId": "string", "sender": "string", "currency": "Orders.Currency", "currency$id": "string", "requestHtml": "string", "priceShipping": "number", "bodyText": "string", "requestedItemIds": "This.CustomerRequestItem.Id[]", "discountPercent": "number", "offerNumber": "string", "request": "Orders.CustomerRequest", "requestId": "Orders.CustomerRequest.Id", "items": "Orders.VendorOfferItem[]", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze(["vendor", "status", "currency"] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ request: () => Orders.CustomerRequest } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({ items: () => Orders.VendorOfferItem } as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θvendor = Signals.proxySignalDeferred<This.Vendor>(() => (new This.Vendor()) as any);
    private readonly θstatus = Signals.proxySignalDeferred<This.VendorOfferStatus>(() => (new This.VendorOfferStatus(This.VendorOfferStatus.NotRequested)) as any);
    private readonly θreceivedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θmessageId = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θsender = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θcurrency = Signals.proxySignalDeferred<This.Currency>(() => (new This.Currency()) as any);
    private readonly θrequestHtml = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θpriceShipping = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θbodyText = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θrequestedItemIds = Signals.proxySignalDeferred<This.CustomerRequestItem.Id[]>(() => (undefined) as any);
    private readonly θdiscountPercent = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θofferNumber = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θrequest = Signals.proxySignalDeferred<Orders.CustomerRequest>(() => (undefined) as any);
    private readonly θrequestId = Signals.proxySignalDeferred<Orders.CustomerRequest.Id>(() => (undefined) as any);
    private readonly θitems = Signals.proxySignalDeferred<Orders.VendorOfferItem[]>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.VendorOffer' {
        return 'Orders.VendorOffer'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.VendorOffer' {
        return 'Orders.VendorOffer'
    }

    static get __baseType(): 'Orders.VendorOffer' {
        return 'Orders.VendorOffer'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.VendorOffer' {
        return 'Orders.VendorOffer'
    }

    get [BoInfoSymbol]() {
        return Orders__VendorOffer[BoInfoSymbol]
    }

    get vendor(): This.Vendor {
        return this.θvendor?.()
    }

    set vendor(vendor: This.Vendor | This.Vendor.Id) {
        this.θvendor().θupdate(vendor)
    }

    @jsonProperty(Number)
    get 'vendor$id'(): This.Vendor.Id {
        return this.θvendor?.()?.id
    }

    set 'vendor$id'(vendor: number) {
        this.θvendor().θupdate(vendor as This.Vendor.Id)
    }

    get status(): This.VendorOfferStatus {
        return this.θstatus?.()
    }

    set status(status: This.VendorOfferStatus | This.VendorOfferStatus.Id) {
        this.θstatus().θupdate(status)
    }

    @jsonProperty(String)
    get 'status$id'(): This.VendorOfferStatus.Id {
        return this.θstatus?.()?.id
    }

    set 'status$id'(status: string) {
        this.θstatus().θupdate(status as This.VendorOfferStatus.Id)
    }

    get receivedOn(): Date {
        return this.θreceivedOn?.()
    }

    set receivedOn(receivedOn) {
        this.θreceivedOn.set(coerceDataType(receivedOn, 'Date', false, true))
    }

    get messageId(): string {
        return this.θmessageId?.()
    }

    set messageId(messageId) {
        this.θmessageId.set(coerceDataType(messageId, 'string', false, true))
    }

    get sender(): string {
        return this.θsender?.()
    }

    set sender(sender) {
        this.θsender.set(coerceDataType(sender, 'string', false, true))
    }

    get currency(): This.Currency {
        return this.θcurrency?.()
    }

    set currency(currency: This.Currency | This.Currency.Id) {
        this.θcurrency().θupdate(currency)
    }

    @jsonProperty(String)
    get 'currency$id'(): This.Currency.Id {
        return this.θcurrency?.()?.id
    }

    set 'currency$id'(currency: string) {
        this.θcurrency().θupdate(currency as This.Currency.Id)
    }

    get requestHtml(): string {
        return this.θrequestHtml?.()
    }

    set requestHtml(requestHtml) {
        this.θrequestHtml.set(coerceDataType(requestHtml, 'string', false, true))
    }

    get priceShipping(): number {
        return this.θpriceShipping?.()
    }

    set priceShipping(priceShipping) {
        this.θpriceShipping.set(coerceDataType(priceShipping, 'number', false, true))
    }

    get bodyText(): string {
        return this.θbodyText?.()
    }

    set bodyText(bodyText) {
        this.θbodyText.set(coerceDataType(bodyText, 'string', false, true))
    }

    get requestedItemIds(): This.CustomerRequestItem.Id[] {
        return this.θrequestedItemIds?.()
    }

    set requestedItemIds(requestedItemIds) {
        this.θrequestedItemIds.set(coerceDataType(requestedItemIds, 'This.CustomerRequestItem.Id[]', false, true))
    }

    get discountPercent(): number {
        return this.θdiscountPercent?.()
    }

    set discountPercent(discountPercent) {
        this.θdiscountPercent.set(coerceDataType(discountPercent, 'number', false, true))
    }

    get offerNumber(): string {
        return this.θofferNumber?.()
    }

    set offerNumber(offerNumber) {
        this.θofferNumber.set(coerceDataType(offerNumber, 'string', false, true))
    }

    get request(): Orders.CustomerRequest {
        return this.θrequest?.()
    }

    set request(request) {
        this.θrequest.set(coerceDataType(request, Orders.CustomerRequest, false, true))
        if (request) {
            this.θrequestId.set(request.id)
        } else if (request === null && request) {
            this.θrequestId.set(null)
        }
    }

    get requestId(): Orders.CustomerRequest.Id {
        return this.θrequestId?.()
    }

    set requestId(requestId) {
        if (requestId === null) this.θrequest.set(null)
        if (this.request?.id && requestId != this.request.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θrequestId.set(coerceDataType(requestId, 'Orders.CustomerRequest.Id', false, true))
    }

    get items(): Orders.VendorOfferItem[] {
        return this.θitems?.()
    }

    set items(items) {
        this.θitems.set(coerceDataType(items, Orders.VendorOfferItem, true, true))
        this.items?.forEach?.(item => { if (item && "offer" in item) item.offer = this as any })
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__VendorOffer>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                items: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__VendorOffer()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__VendorOffer>, restrictToClass?: Class<Partial<Orders__VendorOffer>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('vendor$id', 'status$id', 'receivedOn', 'messageId', 'sender', 'currency$id', 'requestHtml', 'priceShipping', 'bodyText', 'requestedItemIds', 'discountPercent', 'offerNumber', 'request', 'requestId', 'items', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    getItemForReqItem(requestItemId: This.CustomerRequestItem.Id): This.VendorOfferItem {
        return this.items.find(item => item.requestItemId == requestItemId)
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__VendorOffer {
        return equal(this, other)
    }
}

namespace Orders__VendorOffer { }

export import VendorOffer = Orders__VendorOffer
setTimeout(() => {
    jsonProperty(() => Date)(Orders__VendorOffer.prototype, 'receivedOn')
    jsonProperty(() => String)(Orders__VendorOffer.prototype, 'messageId')
    jsonProperty(() => String)(Orders__VendorOffer.prototype, 'sender')
    jsonProperty(() => String)(Orders__VendorOffer.prototype, 'requestHtml')
    jsonProperty(() => Number)(Orders__VendorOffer.prototype, 'priceShipping')
    jsonProperty(() => String)(Orders__VendorOffer.prototype, 'bodyText')
    jsonArrayProperty(() => Orders.CustomerRequestItem.Id)(Orders__VendorOffer.prototype, 'requestedItemIds')
    jsonProperty(() => Number)(Orders__VendorOffer.prototype, 'discountPercent')
    jsonProperty(() => String)(Orders__VendorOffer.prototype, 'offerNumber')
    jsonProperty(() => Orders.CustomerRequest)(Orders__VendorOffer.prototype, 'request')
    jsonProperty(() => Orders.CustomerRequest.Id)(Orders__VendorOffer.prototype, 'requestId')
    jsonArrayProperty(() => Orders.VendorOfferItem)(Orders__VendorOffer.prototype, 'items')
    jsonProperty(() => Date)(Orders__VendorOffer.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOffer.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__VendorOffer.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOffer.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__VendorOffer.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOffer.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__VendorOffer.prototype, 'versionNumber')
})

export const VendorOfferθId = Number;

export type VendorOfferθId = number;

namespace Orders__VendorOffer {
    export type Id = NominalType<number, 'Orders.VendorOffer'>

}
